import type { PageType, PageId } from '@/pages/DiscoverPageV2/constants';

export const getPageType = (id?: PageId | string): PageType => {
  switch (id) {
    case '240709':
      return 'Dividend';
    case '215176':
      return 'Gold';
    case '153':
      return 'Growth';
    default:
      return 'Dividend';
  }
};

/**
 * These hard coded statement lists will eventually be supplied via the grid rules from the BE
 */
export const getStatementKeys = (type?: PageType): string[] => {
  switch (type) {
    case 'Dividend':
      return [
        'IsDividendStable',
        'IsDividendCovered',
        'IsDividendGrowing',
        'IsDividendCoveredIn3Years',
        'IsDividendYieldTopTier',
        'IsDividendSignificant',
      ];
    case 'Gold':
      return [
        'IsReturnOnAssetsBetterThanIndustry',
        'IsProfitable',
        'IsDebtCoveredByCashflow',
        'IsInterestCoveredByProfit',
        'IsDebtLevelAppropriate',
      ];
    case 'Growth':
      return [
        'IsExpectedProfitGrowthAboveRiskFreeRate',
        'IsExpectedAnnualProfitGrowthAboveMarket',
        'IsExpectedAnnualProfitGrowthHigh',
        'IsExpectedRevenueGrowthAboveMarket',
        'IsExpectedRevenueGrowthHigh',
        'IsReturnOnEquityForecastAboveBenchmark',
      ];
    default:
      return [];
  }
};
